<template>
  <div>
    <div class="zt5" v-if="list.length > 0" v-for="(itm, i) in list" :key="i">
      <div class="tz2">
        <div class="tt">
          <div class="sn">
            <img class="logo" src="~@/../static/v2/order/logo.png" mode="widthFix"/>
            {{itm.sn}}
          </div>
          <div class="status status_1"> {{itm.status_str}} </div>
        </div>
      </div>
      <div class="mid_boder">
        <img class="mid_boder_img " src="~@/../static/v2/order/boder.png" mode="widthFix"/>
      </div>

      <div class="staterandtime goodsse ">
        <div class="date">
          {{itm.rote.home_cn}}
        </div>
        <div class="">
          {{itm.json.jp_tit}}
        </div>
        <div class="top">
          <div class="ggz">
            <img class="iiimzz2" src="~@/../static/v3/timeer.png" mode="widthFix"/>
            <div class="tttxx">
              {{itm.date}}
            </div>
          </div>
        </div>
      </div>

      <div class="mid_boder">
        <img class="mid_boder_img " src="~@/../static/v2/order/boder.png" mode="widthFix"/>
      </div>
      <div class="boot1">
        <div class="info">
          <div class="is">
            {{ $lang(42630)}}： <span class="eeee"> {{ itm.pay_time }} </span>
          </div>
          <div class="is">
            {{$lang(42366)}}： <span class="eeee"> {{itm.mail}} </span>
          </div>

          <div v-for="(vo, x) in itm.contacts" :key="x" class="is">
            {{$lang(106462)}}：
            <div class="it">
              <span class="eeee e1">
                {{ vo.name}}
              </span>
              <span class="eeee e2">
                {{ vo.strs.sex}}
              </span>
              <span class="eeee e3">
                {{ vo.age}}
              </span>
              <span class="eeee e4">
                {{ $lang(42361)}}
              </span>
            </div>
          </div>
        </div>

        <div class="price">
          {{itm.amount}} {{ $lang(42374) }}
        </div>
      </div>

      <div class="boot2">
        <div class="btns">
          <div class="b_tn" v-if="itm.status==0" @click="jump('/goods/pay?sn=' + itm.sn)">
            {{$lang(42644)}}
          </div>

          <div class="b_tn" v-if="itm.strs.show_btn" @click="show_back(i)"> {{$lang(50942)}}</div>
          <div class="b_tn" v-if="itm.back_status > 0" @click="show_note(i)">{{itm.strs.back_status}}
          </div>
        </div>
      </div>
    </div>

    <div v-if="list.length == 0">
      <el-empty marginTop="200" margin mode="data">
      </el-empty>
      <div class="" style="height: 200px;">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'goods_order_list',
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    jump(path) {
      this.$emit('jump', path);
    },
    show_back(index) {
      this.$emit('show-back', index);
    },
    show_note(index) {
      this.$emit('show-note', index);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/goods_order_list.vue